import React, { useRef, useState, useEffect, useCallback } from "react";
import { View, Animated, StyleSheet, TouchableOpacity } from "react-native";
import Text from "components/Text";

import { colors } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";

const size = 40;
export default function Switch(props: SwitchT) {
  const {
    value,
    onChange,
    activeLabel,
    inactiveLabel,
    activeColor,
    inactiveColor,
  } = props;
  const {
    company: { color },
  } = useRecoilValue(authAtom);
  const [innerValue, setInnerValue] = useState<0 | 1>(value || 0);
  const animVar = useRef(new Animated.Value(value || 0)).current;

  const onActive = useCallback(() => {
    Animated.timing(animVar, {
      toValue: 1,
      duration: 100,
      useNativeDriver: false,
    }).start(() => {
      setInnerValue(1);
      onChange && onChange(1);
    });
  }, [animVar, onChange]);

  const onInActive = useCallback(() => {
    Animated.timing(animVar, {
      toValue: 0,
      duration: 100,
      useNativeDriver: false,
    }).start(() => {
      setInnerValue(0);
      onChange && onChange(0);
    });
  }, [animVar, onChange]);

  useEffect(() => {
    if (value === 0 || value === 1) {
      setInnerValue(value);
      animVar.setValue(value);
    }
  }, [value, animVar]);

  const translateX = animVar.interpolate({
    inputRange: [0, 1],
    outputRange: [size / 2, 0],
  });

  const backgroundColor = animVar.interpolate({
    inputRange: [0, 1],
    outputRange: [inactiveColor || colors.placeholder, activeColor || color],
  });

  const onPress = innerValue === 0 ? onActive : onInActive;

  return (
    <View style={styles.mainContainer}>
      <TouchableOpacity
        activeOpacity={0.9}
        style={{ ...styles.touchableContainer }}
        onPress={onPress}
      >
        <Animated.View style={{ ...styles.container, backgroundColor }}>
          <Animated.View
            style={{ ...styles.buttonWrapper, transform: [{ translateX }] }}
          >
            <View
              style={{
                ...styles.button,
                backgroundColor:
                  innerValue > 0 ? colors.white : colors.lightButtons,
              }}
            />
          </Animated.View>
        </Animated.View>
      </TouchableOpacity>
      {activeLabel && inactiveLabel && (
        <Text
          weight="medium"
          style={{ marginRight: 3, bottom: 2 }}
          color={innerValue ? color : colors.textColorGray}
        >
          {innerValue === 0 ? inactiveLabel : activeLabel}
        </Text>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  mainContainer: { flexDirection: "row-reverse", alignItems: "center" },

  touchableContainer: { width: size, aspectRatio: 2, borderRadius: 100 },

  container: { flex: 1, borderRadius: 100, backgroundColor: "green" },

  buttonWrapper: {
    padding: 2,
    aspectRatio: 1,
    width: size / 2,
    borderRadius: size,
  },

  button: { flex: 1, borderRadius: 100 },
});
